// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { cartLineWithNotes } from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import { cartLineCardExpandedStyles } from "@conklin/Overrides/Components/CartLineCardExpanded";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productBrand = {
    nameLink: {
        css: css`
            font-weight: ${fontConfig.weight.regular};
            align-self: flex-start;
            margin-bottom: 2px;
        `,
    },
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.productInfoContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        margin-bottom: 8px;
    `,
};
cartLineCardExpandedStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardExpandedStyles.extendedUnitNetPriceGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
    `,
};

cartLineCardExpandedStyles.configurationOptionText = {
    css: css`
        display: block;
    `,
};

cartLineCardExpandedStyles.configurationGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.cartLineErrorMessageGridItem = {
    width: 12,
    css: css`
        margin-top: 16px;
    `,
};

cartLineCardExpandedStyles.addToListLink = {
    ...mergeWithCss(cartLineSharedStyles.addToListLink, {
        css: css`
            &&& {
                ${xScreen("lte", "md")} {
                    margin-top: 12px;
                    float: left;
                }
            }
        `,
    }),
};

cartLineCardExpandedStyles.cartLineContainer = cartLineWithNotes;

cartLineCardExpandedStyles.quoteMessageWrapper = {
    ...cartLineSharedStyles.quoteMessage?.quoteMessageWrapper,
};

cartLineCardExpandedStyles.quoteTotal = {
    ...cartLineSharedStyles.quoteMessage?.quoteTotal,
};
cartLineCardExpandedStyles.quoteText = {
    ...cartLineSharedStyles.quoteMessage?.quoteText,
};

cartLineCardExpandedStyles.quoteTooltip = {
    ...cartLineSharedStyles.quoteMessage?.quoteTooltip,
};
